import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: 'var(--bg-dark)',
      borderTop: '3px solid var(--gold-primary)',
      marginTop: '120px'
    }}>
      <div className="container" style={{
        padding: '60px 40px 40px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          {/* Company Info */}
          <div>
            <img 
              src="/logo.jpg" 
              alt="Vitta Finance Academy" 
              style={{
                height: '60px',
                width: 'auto',
                marginBottom: '20px'
              }}
            />
            <p className="body-small" style={{
              marginBottom: '20px',
              lineHeight: 1.6,
              color: 'var(--neutral-light)'
            }}>
              Canada's Leading CIRO Exam Prep Provider. Trusted by over 30,000 learners.
            </p>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: 'var(--neutral-light)'
            }}>
              <Mail size={18} color="var(--gold-primary)" />
              <a href="mailto:info@vittafinance.ca" style={{
                color: 'var(--neutral-light)',
                textDecoration: 'none',
                fontSize: '1rem'
              }}>
                info@vittafinance.ca
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontWeight: 600,
              fontSize: '1.125rem',
              color: 'var(--gold-primary)',
              marginBottom: '20px'
            }}>
              Quick Links
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem',
                  transition: 'color 0.3s ease'
                }}>
                  Home
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/courses" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem',
                  transition: 'color 0.3s ease'
                }}>
                  Courses
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/blog" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem',
                  transition: 'color 0.3s ease'
                }}>
                  Blog
                </Link>
              </li>
              {/* TEMPORARILY HIDDEN - Unhide in 2 days
              <li style={{ marginBottom: '12px' }}>
                <Link to="/about" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem',
                  transition: 'color 0.3s ease'
                }}>
                  About Us
                </Link>
              </li>
              */}
              <li style={{ marginBottom: '12px' }}>
                <Link to="/contact" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem',
                  transition: 'color 0.3s ease'
                }}>
                  Contact
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/disclaimer" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem',
                  transition: 'color 0.3s ease'
                }}>
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h4 style={{
              fontWeight: 600,
              fontSize: '1.125rem',
              color: 'var(--gold-primary)',
              marginBottom: '20px'
            }}>
              CIRO Courses
            </h4>
            <ul style={{
              listStyle: 'none',
              padding: 0
            }}>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/cire-exam" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem'
                }}>
                  Canadian Investment Regulatory Exam (CIRE)
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/rse-exam" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem'
                }}>
                  Retail Securities Exam (RSE)
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/ise-exam" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem'
                }}>
                  Institutional Securities Exam (ISE)
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/derivatives-exam" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem'
                }}>
                  Derivatives Exam
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/traders-exam" style={{
                  color: 'var(--neutral-light)',
                  textDecoration: 'none',
                  fontSize: '1rem'
                }}>
                  Traders Licensing Exam
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 style={{
              fontWeight: 600,
              fontSize: '1.125rem',
              color: 'var(--gold-primary)',
              marginBottom: '20px'
            }}>
              Follow Us
            </h4>
            <div style={{
              display: 'flex',
              gap: '16px'
            }}>
              <a href="https://www.youtube.com/@FinanceinCanada" target="_blank" rel="noopener noreferrer" style={{
                color: 'var(--neutral-light)',
                transition: 'color 0.3s ease'
              }}>
                <Youtube size={24} />
              </a>
              <a href="https://www.linkedin.com/in/amina-beecroft/" target="_blank" rel="noopener noreferrer" style={{
                color: 'var(--neutral-light)',
                transition: 'color 0.3s ease'
              }}>
                <Linkedin size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '30px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <p className="body-small" style={{
            margin: 0,
            color: 'var(--neutral-light)'
          }}>
            © 2026 Vitta Finance Academy Inc. All rights reserved.
          </p>
          <p className="body-small" style={{
            margin: 0,
            color: 'var(--neutral-light)'
          }}>
            Powered by <a href="https://kajabi.com" target="_blank" rel="noopener noreferrer" style={{
              color: 'var(--gold-primary)',
              textDecoration: 'none'
            }}>Kajabi</a>
          </p>
        </div>
      </div>

      <style>{`
        footer a:hover {
          color: var(--gold-primary) !important;
        }
      `}</style>
    </footer>
  );
};

export default Footer;